import i18n from 'i18n';
import { CompositeSettingStatus, ScreenProperty } from './ChannelGroup';

/**
 * ECOPD-5722：連台渠道的合成設定在渠道詳細頁與編輯頁都要顯示，兩頁的欄位組裝方式不同
 * （`InfoDisplaySection` 的 `{ label, value, extra }` vs `FormConfig` 的 addLabel），
 * 所以「值與錯誤訊息怎麼決定」抽在這裡，渲染各自負責。
 */

const SIZE_ERROR_I18N_KEYS: { [key: string]: string } = {
  [CompositeSettingStatus.SIZE_MISSING]:
    'channelGroup.compositeSettingError.sizeMissing',
  [CompositeSettingStatus.SIZE_NOT_MULTIPLE]:
    'channelGroup.compositeSettingError.sizeNotMultiple',
  [CompositeSettingStatus.SIZE_TOO_SMALL]:
    'channelGroup.compositeSettingError.sizeTooSmall'
};

/**
 * 三態：`true` / `false` / 不存在。不存在時回「無」而不是「不可以」——
 * 「RMax 還沒同步」與「不要合成」是兩種不同狀態，前者要擋、後者正常運作。
 */
export const getCompositeCreativeText = (
  screenProperty?: ScreenProperty
): string => {
  const isCompositeCreative = screenProperty?.isCompositeCreative;
  if (isCompositeCreative === undefined) {
    return i18n.t('common.labels.noData');
  }
  return isCompositeCreative
    ? i18n.t('common.labels.yes')
    : i18n.t('common.labels.no');
};

export const getCompositePixelSizeText = (
  screenProperty?: ScreenProperty
): string => {
  const width = screenProperty?.compositePixelWidth;
  const height = screenProperty?.compositePixelHeight;
  if (width === undefined || height === undefined) {
    return i18n.t('common.labels.noData');
  }
  return `${width} x ${height}`;
};

/** 只有「尚未同步」是在講合成旗標本身，掛在那一列上。 */
export const getCompositeCreativeError = (
  status?: CompositeSettingStatus
): string | undefined =>
  status === CompositeSettingStatus.NOT_SYNCED
    ? i18n.t('channelGroup.compositeSettingError.notSynced')
    : undefined;

/** 其餘三種都是在講播放尺寸，掛在尺寸那一列上。 */
export const getCompositePixelSizeError = (
  status?: CompositeSettingStatus
): string | undefined => {
  const key = status ? SIZE_ERROR_I18N_KEYS[status] : undefined;
  return key ? i18n.t(key) : undefined;
};
